import React, { useState } from 'react';
import { LanguageMenuProps } from '../../../utils/types';
import LanguageDropdownMenu from './language-dropdown';
import '../../../App.css';
import './language-menu.css';
import { findLanguageIndex, StripDoubleQuotes } from '../../../utils/functions';
import useLocalStorage from 'use-local-storage';
import { LANGUAGE_OPTIONS } from '../../../utils/common/constants';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  setLanguageDropdownMenuDisplayed,
  setLanguageIndex,
  toggleLanguageDropdownMenuDisplayed,
} from '../../../app-slice';
import { persistLanguageSelection, setPreferences } from '../../../app-actions';

const LanguageMenu: React.FC = () => {
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  const dispatch = useAppDispatch();
  // global state variables.
  const sG_loggedIn: boolean | undefined = useAppSelector(
    (state) => state.global.loggedIn,
  );

  const sLanguageDropdownMenuDisplayed: boolean = useAppSelector(
    (state) => state.app.languageDropdownMenuDisplayed,
  );
  const sLanguageIndex: number | undefined = useAppSelector(
    (state) => state.app.languageIndex,
  );
  const currentLang = sLanguageIndex
    ? LANGUAGE_OPTIONS[sLanguageIndex]
    : LANGUAGE_OPTIONS[0];

  //	-------------------------------------------------
  //
  //	Toggle dropdown
  //
  //	-------------------------------------------------

  function onClickHandler(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    dispatch(toggleLanguageDropdownMenuDisplayed());
  }

  //	-------------------------------------------------
  //
  //	Handle selecting a language
  //
  //	-------------------------------------------------

  function handleLanguageSelect(value: string) {
    dispatch(persistLanguageSelection(value));
    dispatch(setLanguageIndex(findLanguageIndex({ language: value })));
    dispatch(setLanguageDropdownMenuDisplayed(false));
    if (sG_loggedIn === true) dispatch(setPreferences({ language: value }));
  }

  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: '0px 0px 0px 0px',
      }}
    >
      <button
        className="language-menu"
        name="lstLanguage"
        type="button"
        onClick={onClickHandler}
        data-menu-displayed={sLanguageDropdownMenuDisplayed ? 'T' : 'F'}
      >
        <span style={{ margin: '0px 10px 0px 0px' }}>{currentLang.label}</span>
        {currentLang.icon && (
          <img src={currentLang.icon} role="presentation" alt="" width="30" height="16" />
        )}
      </button>

      <LanguageDropdownMenu
        buttonHandler={(e: React.MouseEvent<HTMLButtonElement>) => {
          const name = e.currentTarget.name.replace('btnLanguage_', '');
          handleLanguageSelect(name);
        }}
      />
    </div>
  );
};

export default LanguageMenu;
